import logoImg from '../assets/logo.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="user-footer">
      <div className="user-footer-inner">
        <div className="user-footer-left">
          <a className="user-footer-caption" href="/terms/">Условия использования</a>
          <a className="user-footer-caption" href="/privacy/">Политика конфиденциальности</a>
          <a className="user-footer-caption" href="/delete-account/">Удаление аккаунта и данных</a>
        </div>

        <div className="user-footer-right">
          <span className="user-footer-copy">© 2026 Ksynik. Все права защищены</span>
          <div className="user-footer-brand">
            <img src={logoImg} alt="Ксюник" />
            <div className="user-footer-brand-text">
              <span>Сокол</span>
              <span>Оферта</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
